import ContainerStyledComponent from 'styled-components';

export const LoadingContainerStyle = ContainerStyledComponent.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: auto;
  width: 100%;
  font-size: 1.5rem;
  font-family: var(--app-font);
`;

export default {
  LoadingContainerStyle,
};
